var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3865 1.09082C19.1288 -0.363687 21.2071 -0.363684 21.9494 1.09082L26.7501 10.4978C27.0407 11.0672 27.586 11.4634 28.2174 11.5638L38.6474 13.2226C40.2601 13.4791 40.9024 15.4557 39.7484 16.6111L32.2854 24.0838C31.8336 24.5361 31.6253 25.1772 31.7249 25.8087L33.3703 36.2409C33.6248 37.8539 31.9434 39.0755 30.4879 38.335L21.0748 33.5464C20.505 33.2565 19.8309 33.2565 19.2611 33.5464L9.84801 38.335C8.39256 39.0755 6.71118 37.8539 6.9656 36.2408L8.61104 25.8087C8.71064 25.1772 8.50235 24.5361 8.05058 24.0838L0.587518 16.6111C-0.566419 15.4557 0.0758128 13.4791 1.6885 13.2226L12.1186 11.5638C12.7499 11.4634 13.2952 11.0672 13.5859 10.4978L18.3865 1.09082Z",
    fill: "#EEA42E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.dde75435b9a8e93c7a310795aa2d8d07.svg";
export { ForwardRef as ReactComponent };